import React from 'react';
import DatePicker from 'react-datepicker';
import CheckboxInput from '../checkbox-input';

const DateOfBirthRow = ({filter, conditionsList, updateCondition, updateDateConditionChild, updateValue}) => {
  const datesVariants = ['today', 'tomorrow', 'one_week_ago', 'one_week_from_now', 'one_month_ago',
    'one_month_from_now', 'number_of_days_ago', 'number_of_days_from_now', 'exact_date']

  const updateValueWithTime = (value) => {
    updateValue(moment().set({'year': value.get('year'), 'month': value.get('month'), 'date': value.get('date')}))
  }

  const updateConditionWithArgs = (value) => {
    updateCondition(filter.condition.split('&').map((el,index) => index == 0 ? value : el).join('&'))
  }

  const updateConditionWithExYear = (enabled) => {
    var condArr = filter.condition.split('&')

    if (enabled) condArr.push('exYear')
    else condArr = condArr.filter((el) => el != 'exYear')

    updateCondition(condArr.join('&'))
  }

  return (
    <span>
      <select value={filter.condition.split('&')[0]} onChange={e=> updateConditionWithArgs(e.target.value)}>
        { conditionsList.map((o, i) => <option key={i} value={o}>{o}</option>) }
      </select>&nbsp;
      { !['is empty', 'is not empty'].includes(filter.condition) &&
        <select value={filter.conditionChild} onChange={e=> updateDateConditionChild(e.target.value)}>
          { datesVariants.map((o, i) =>
            <option key={i} value={o}>{o.replace(/_/g, ' ')}</option>) }
        </select>
      }&nbsp;
      {filter.conditionChild == 'exact_date' &&
        <label onClick={e => e.preventDefault()}>
          <DatePicker
            onChange={(date) => updateValueWithTime(date || moment())}
            selected={moment(filter.value)}
          />
        </label>
      }
      {['number_of_days_ago','number_of_days_from_now'].includes(filter.conditionChild) &&
        <input
          className='filter-form-input' placeholder='Select a number' type='number' value={filter.value}
          onChange={(e) => {updateValue( e.target.value)}}
        />
      }&nbsp;
      <span className='date-played-addons'>
        exclude year&nbsp;
        <CheckboxInput
          className='boolean-checkbox'
          checked={filter.condition.split('&').includes('exYear')}
          onChange={(e)=>{updateConditionWithExYear(e.target.checked)}}/>
      </span>
    </span>
  )
}

export default DateOfBirthRow
